import api from "./api";

import { buildQueryParams } from "../utils/buildQueryParams";

class CompositionService {
  getCompositions(params) {
    const queryParams = buildQueryParams(params);
    return api.get(`v2/api/compositions?${queryParams}`);
  }

  getContentById(id) {
    return api.get(`v2/api/compositions/${id}`);
  }
}

export default new CompositionService();
